// Debug utility to help troubleshoot environment detection
export const debugEnvironment = () => {
  const env = {
    NODE_ENV: process.env.NODE_ENV,
    hostname: typeof window !== 'undefined' ? window.location.hostname : 'server-side',
    href: typeof window !== 'undefined' ? window.location.href : 'server-side',
    isLocalhost: typeof window !== 'undefined' ? window.location.hostname === 'localhost' : false,
    isVercel: typeof window !== 'undefined' ? window.location.hostname.includes('vercel.app') : false,
    isProduction: process.env.NODE_ENV === 'production',
  };
  
  console.log('Environment Debug Info:', env);
  return env;
};

// Test image URL generation
export const testImageUrl = (imagePath) => {
  // Import the function dynamically to avoid circular dependencies
  import('./imageUtils').then(({ getImageUrl }) => {
    const url = getImageUrl(imagePath);
    console.log(`Image URL for "${imagePath}":`, url);
    return url;
  }).catch(error => {
    console.error('Error importing imageUtils:', error);
  });
};

// Comprehensive test function for image utilities
export const testImageUtilities = () => {
  console.log('=== Testing Image Utilities ===');
  
  // Test environment detection
  const env = debugEnvironment();
  
  // Test with various image paths
  const testCases = [
    'test-image.jpg',
    '1722413259_nazreth.jpg',
    'company-logo.png',
    '',
    null,
    undefined,
    'undefined',
    'null'
  ];
  
  testCases.forEach(testCase => {
    console.log(`Testing with: "${testCase}"`);
    testImageUrl(testCase);
  });
  
  console.log('=== End Image Utilities Test ===');
};

// Global test function for browser console
if (typeof window !== 'undefined') {
  window.testImageUtils = () => {
    console.log('=== Global Image Utils Test ===');
    testImageUtilities();
    
    // Test specific cases
    import('./imageUtils').then(({ getImageUrl, getCompanyLogoUrl }) => {
      console.log('Testing specific cases:');
      console.log('getImageUrl("test.jpg"):', getImageUrl('test.jpg'));
      console.log('getCompanyLogoUrl("logo.png"):', getCompanyLogoUrl('logo.png'));
      console.log('getImageUrl(undefined):', getImageUrl(undefined));
    });
  };
  
  window.debugImageEnv = () => {
    debugEnvironment();
  };
} 